import React, { useMemo } from "react";
import Select, { Props } from "react-select";

// Internal
import "./SelectDropdown.scss";

type SelectDropdownProps = {
  containerClassName?: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
};

export const SelectDropdown = ({
  containerClassName,
  label,
  placeholder,
  required,
  ...rest
}: Props & SelectDropdownProps) => {
  const {
    styles,
    menuPortalTarget,
    menuPosition,
    menuShouldScrollIntoView,
    ...selectProps
  } = rest as Props & {
    styles?: any;
    menuPortalTarget?: HTMLElement | null;
    menuPosition?: "fixed" | "absolute";
    menuShouldScrollIntoView?: boolean;
  };

  const mergedStyles = useMemo(() => {
    const userMenuPortal = styles?.menuPortal;
    return {
      ...styles,
      menuPortal: (base: any) => {
        const nextBase = userMenuPortal ? userMenuPortal(base) : base;
        return { ...nextBase, zIndex: Math.max(nextBase?.zIndex ?? 0, 9999) };
      },
    } as any;
  }, [styles]);

  return (
    <div className={`select-box-container ${containerClassName}`}>
      {label && (
        <label className="label-style">
          {label} {required && <span className="mandatory-field">*</span>}
        </label>
      )}
      <Select
        className="label-style"
        {...selectProps}
        placeholder={placeholder}
        styles={mergedStyles}
        menuPortalTarget={
          menuPortalTarget ??
          (typeof document !== "undefined" ? document.body : undefined)
        }
        menuPosition={menuPosition ?? "fixed"}
        menuShouldScrollIntoView={menuShouldScrollIntoView ?? false}
      />
    </div>
  );
};
